import { useEffect } from 'react';

import { qalTrackEventAction } from '~/thunks/analytics';
import { getActivePagePath, useIsFirstRender } from '~/utils/analytics/helpers';

import { useAppDispatch } from './index';

// This effect tracks the "optimize.activate" event using QAL (QBE Analytics Library).
// When the component is mounted, the `qalTrackEventAction` is dispatched to notify
// Webtrends about the "optimize.activate" event. This helps reload their SDK for
// dynamic content visibility tracking. The cleanup function ensures that no further
// actions are dispatched after the component is unmounted.
export const useTrackOptimizeActivate = () => {
  const dispatch = useAppDispatch();
  const isFirstRender = useIsFirstRender();
  const activeFullPagePath = getActivePagePath();

  useEffect(() => {
    dispatch(
      qalTrackEventAction({
        event: 'optimize.activate',
        eventAction: isFirstRender ? 'mount' : 'update',
        data: {
          virtualPagePath: activeFullPagePath,
        },
      })
    );
  }, [activeFullPagePath, dispatch, isFirstRender]);
};
